import { Apps } from '~/shared';

export const menuApps = [
	Apps.Camera,
	Apps.Message,
	Apps.Ads,
	Apps.Auction,
	Apps.MyBusiness,
	Apps.TruckJob,
];
export const pinnedApps = [Apps.Camera, Apps.Message];
